import { css } from '@emotion/css';

const alert = css`
  margin-left: var(--spacings-2);
  .MuiAlertTitle-root {
    display: flex;
    gap: var(--spacings-1);
    align-items: center;
    margin-bottom: 0;
  }
`;

const link = css`
  cursor: pointer;
  text-decoration: underline;
  color: var(--colors-primary-main);
  &:hover {
    opacity: 0.8;
  }
`;

const modal = css`
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.7);
  }
`;

const content = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--colors-white);
  box-shadow: var(--shadows-24);
  padding: var(--spacings-6) var(--spacings-6) var(--spacings-6)
    var(--spacings-6);
  width: 500px;
  max-height: 90vh;
  overflow: auto;
  border-radius: var(--radius-2);
  position: relative;
`;

const closeButton = css`
  position: absolute !important;
  right: var(--spacings-2) !important;
  top: var(--spacings-2) !important;
  padding: var(--spacings-1) !important;
  color: var(--colors-text-secondary);
  &:hover {
    background-color: var(--colors-action-hover);
  }
`;

const requirementText = css`
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: var(--spacings-1);
  margin-bottom: var(--spacings-2);
  .label {
    font-weight: 500;
    font-size: 0.875rem;
  }
`;

const imageContainer = css`
  margin-top: var(--spacings-3);
  img {
    width: 100%;
    height: auto;
    border-radius: var(--radius-1);
    border: 1px solid var(--colors-divider);
  }
  .title {
    margin-top: var(--spacings-1);
    margin-bottom: var(--spacings-2);
    font-weight: 500;
  }
`;

const IdRequirementsAlertStyles = {
  alert,
  link,
  modal,
  content,
  closeButton,
  requirementText,
  imageContainer,
};

export default IdRequirementsAlertStyles;
